/**
 * Event V2 Repository - GraphQL Fragments
 *
 * Reusable field selections for Event queries and mutations.
 * Ensures field parity with backend GraphQL schema.
 *
 * Note: Fields marked #[graphql(skip)] in backend are excluded.
 * Actor references use complex resolvers (performedByActor, onBehalfOfActor).
 */

import { gql } from '@apollo/client';

export const EVENT_FIELDS_FRAGMENT = gql`
  fragment EventFields on Event {
    # Identity (3 exposed fields — tenantId is skipped)
    id
    eventName
    eventType

    # Formula Interaction (1 exposed — entityId/workflowInstanceId/transactionId/checkpointId/correlationId skipped)
    entityType

    # Classification (5 fields)
    severity
    category
    source
    action
    tags

    # Payload (4 fields)
    oldValue
    newValue
    changeSummary
    metadata

    # Cryptographic Integrity (4 fields)
    hash
    previousEventHash
    signature
    chainVerified

    # Provenance (resolved via complex objects)
    performedAt
    performedByActor {
      id
      displayName
      role
    }
    onBehalfOfActor {
      id
      displayName
      role
    }

    # Lifecycle & Audit (4 fields)
    createdAt
    retentionUntil
    archived
    complianceFrameworks

    # Performance Metadata (2 fields)
    processingDurationMs
    retryCount

    # Append-Only Architecture (3 fields)
    parentId
    originalId
    isActive

    # Computed
    compressedId
  }
`;
